import { Component } from 'react'
import { connect } from 'react-redux'
import WPAPI from 'wpapi'
import PropTypes from 'prop-types'
import { updateContent } from 'store/content'
import { toggleBlockUI } from 'store/blockUI'
import { decode, rootPath } from 'lib/Utils'

class PageDefault extends Component {
  componentDidMount () {
    const wp = new WPAPI({
      endpoint: `${rootPath}/wp-json`
    })

    let contentObject = { type: 'page' }

    this.props.toggleBlockUI(true)
    wp.pages().slug(this.props.params.slug).get()
      .then((data) => {
        this.props.toggleBlockUI(false)
        contentObject.item = data[0]
        contentObject.title = decode(data[0].title.rendered)
        this.props.updateContent(contentObject)
      })
      .catch((error) => {
        console.warn(error)
        this.props.toggleBlockUI(false)
      })
  }

  render () {
    return null
  }
}

const mapDispatchToProps = {
  updateContent: (content) => updateContent(content),
  toggleBlockUI: (block) => toggleBlockUI(block)
}

PageDefault.propTypes = {
  updateContent: PropTypes.func,
  toggleBlockUI: PropTypes.func,
  params: PropTypes.object
}

export default connect(null, mapDispatchToProps)(PageDefault)



// WEBPACK FOOTER //
// ./src/routes/PageDefault/index.js